import React from "react"
import PropTypes from "prop-types"
import {Card, Col, Row} from "antd"
import LovTransfer from "./LovTransfer";
import LovSelector from "./LovSelector";
import * as LovActions from "../../reducers/lov";
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import LovResultTable from "./LovResultTable";
import {LoadingIndicator} from "../../util/Util";
import {Tooltip, Icon} from 'antd';

class GlobalLovView extends React.Component {

    static propTypes = {
        mappings: PropTypes.array.isRequired,
        getMapping: PropTypes.func.isRequired,
        gettingMapping: PropTypes.bool.isRequired,
        selectedType: PropTypes.string,
        selectedCountry: PropTypes.string,
        selectedCode: PropTypes.string,
        setCountry: PropTypes.func.isRequired,
        setType: PropTypes.func.isRequired,
        globalLovs: PropTypes.object.isRequired,
        localLovs: PropTypes.object.isRequired,
        addMapping: PropTypes.func.isRequired,
        saveMapping: PropTypes.func.isRequired,
        removeMapping: PropTypes.func.isRequired,
        getLovs: PropTypes.func.isRequired,
        loadingLovs: PropTypes.bool.isRequired,
        saving: PropTypes.bool.isRequired
    };

    state = {
        selectedGlobalType: null,
        selectedGlobaLovs: []
    };

    componentDidMount() {
        this.props.getLovs();
    }

    handleSelect = (selectedKeys) => this.props.getMapping(selectedKeys[0]);

    handleGlobalTypeChange = (value) => this.setState({selectedGlobalType: value});

    handleGlobalLovChange = (selectedKeys, e) => {
        const {selectedGlobalType} = this.state;
        return this.props.addMapping(selectedGlobalType, selectedKeys)
    };

    handleRemoveMapping = (lov) => this.props.removeMapping(lov);

    render() {
        const {selectedGlobalType} = this.state;
        const {
            mappings, gettingMapping, setCountry, setType, selectedCountry, selectedType, globalLovs, localLovs,
            saveMapping, selectedCode, saving, loadingLovs
        } = this.props;

        return <Card title="Global LOVs" className="full-height">
            <LoadingIndicator loading={loadingLovs}>
                <Row gutter={25}>
                    <Col span={6}>
                        <div className="apb-ui-tooltips">
                            <h4>Select a Lov to map</h4>
                            <Tooltip title="Information how to map lovs">
                                <span><Icon type="question-circle-o"/></span>
                            </Tooltip>
                        </div>
                        <LovSelector handleTypeChange={setType} data={localLovs} selectedCountry={selectedCountry}
                                     selectedType={selectedType} handleCountryChange={setCountry}
                                     handleSelect={this.handleSelect}/>
                    </Col>
                    <Col span={6}>
                        <div className="apb-ui-tooltips">
                            <h4>Choose mappings</h4>
                            <Tooltip title="How to choose mappings">
                                <span><Icon type="question-circle-o"/></span>
                            </Tooltip>
                        </div>
                        <LovTransfer mappings={mappings} selectedGlobalType={selectedGlobalType}
                                     handleGlobalLovChange={this.handleGlobalLovChange}
                                     handleGlobalTypeChange={this.handleGlobalTypeChange} globalLovs={globalLovs}
                                     gettingMapping={gettingMapping}/>
                    </Col>
                    <Col span={12}>
                        <LovResultTable mappings={mappings} gettingMapping={gettingMapping} saving={saving}
                                        title="Review your choices" selectedCode={selectedCode}
                                        handleGlobalTypeChange={this.handleGlobalTypeChange}
                                        handleRemove={this.handleRemoveMapping} saveMapping={saveMapping}/>
                    </Col>
                </Row>
            </LoadingIndicator>
        </Card>
    }
}

const mapStateToProps = state => ({
    mappings: state.lov.mappings,
    gettingMapping: state.lov.gettingMapping,
    selectedCountry: state.lov.selectedCountry,
    selectedType: state.lov.selectedType,
    selectedCode: state.lov.selectedCode,
    globalLovs: state.lov.globalLovs,
    localLovs: state.lov.localLovs,
    loadingLovs: state.lov.loadingLovs,
    saving: state.lov.saving
});

const mapDispatchToProps = dispatch => ({
    getMapping: bindActionCreators(LovActions, dispatch).getMapping,
    setCountry: bindActionCreators(LovActions, dispatch).setCountry,
    setType: bindActionCreators(LovActions, dispatch).setType,
    addMapping: bindActionCreators(LovActions, dispatch).addMapping,
    removeMapping: bindActionCreators(LovActions, dispatch).removeMapping,
    saveMapping: bindActionCreators(LovActions, dispatch).saveMapping,
    getLovs: bindActionCreators(LovActions, dispatch).getLovs
});

export default connect(mapStateToProps, mapDispatchToProps)(GlobalLovView)


// WEBPACK FOOTER //
// ./src/js/lovs/map/GlobalLovView.js